// Utilitários para formatação de moeda brasileira

/**
 * Formata um valor numérico para o formato monetário brasileiro
 * @param {string|number} value - Valor a ser formatado
 * @returns {string} - Valor formatado (ex: "1.000,00")
 */
export const formatCurrency = (value) => {
  if (!value && value !== 0) return ''
  
  // Remove tudo que não é dígito
  const numericValue = value.toString().replace(/\D/g, '')
  
  if (!numericValue) return ''
  
  // Converte para número e divide por 100 para ter centavos
  const number = parseInt(numericValue) / 100
  
  // Formata com separadores brasileiros
  return number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

/**
 * Remove formatação monetária e retorna valor numérico
 * @param {string} formattedValue - Valor formatado
 * @returns {number} - Valor numérico
 */
export const parseCurrency = (formattedValue) => {
  if (!formattedValue) return 0
  
  // Remove pontos e substitui vírgula por ponto
  const cleanValue = formattedValue
    .replace(/\./g, '')
    .replace(',', '.')
  
  return parseFloat(cleanValue) || 0
}

/**
 * Manipula a entrada de texto para formatação em tempo real
 * @param {string} value - Valor atual do input
 * @param {string} newValue - Novo valor digitado
 * @returns {string} - Valor formatado para exibição
 */
export const handleCurrencyInput = (newValue) => {
  // Remove tudo que não é dígito
  const numericOnly = newValue.replace(/\D/g, '')
  
  // Se não há dígitos, retorna vazio
  if (!numericOnly) return ''
  
  // Limita a 10 dígitos (até 99.999.999,99)
  const limitedValue = numericOnly.slice(0, 10)
  
  return formatCurrency(limitedValue)
}

/**
 * Converte valor formatado para valor numérico para armazenamento
 * @param {string} formattedValue - Valor formatado (ex: "1.000,50")
 * @returns {string} - Valor para armazenamento (ex: "1000.50")
 */
export const currencyToStorage = (formattedValue) => {
  if (!formattedValue) return ''
  
  const numericValue = parseCurrency(formattedValue)
  return numericValue.toString()
}

/**
 * Converte valor de armazenamento para valor formatado
 * @param {string|number} storageValue - Valor armazenado
 * @returns {string} - Valor formatado para exibição
 */
export const storageToDisplay = (storageValue) => {
  if (!storageValue) return ''
  
  const numericValue = parseFloat(storageValue)
  if (isNaN(numericValue)) return ''
  
  // Multiplica por 100 e converte para string para usar formatCurrency
  const centavos = Math.round(numericValue * 100).toString()
  return formatCurrency(centavos)
}